module.exports = __webpack_public_path__ + "static/media/rpmModeIcon.46fc1435.png";